import React from 'react';
import './Editable.css';
import {EditableSingleSelect} from "./EditableSingleSelect";
import {EditableProps} from "./Editable";

// https://stackoverflow.com/questions/59716981/iana-timezones-for-mainland-united-states
const timeZones = [
  {value: 'America/New_York', label: 'Eastern Time'},
  {value: 'America/Chicago', label: 'Central Time'},
  {value: 'America/Denver', label: 'Mountain Time'},
  {value: 'America/Phoenix', label: 'Mountain Time (Arizona)'},
  {value: 'America/Los_Angeles', label: 'Pacific Time'},
  {value: 'America/Anchorage', label: 'Alaska Time'},
  {value: 'Pacific/Honolulu', label: 'Hawaii-Aleutian Time'}
]

export const EditableTimeZoneField = <EnclosingType extends object>(props: EditableProps<EnclosingType, string>) => {
  
  return <EditableSingleSelect {...props} options={timeZones}/>
}
